import { render, staticRenderFns } from "./participant.vue?vue&type=template&id=b1f9faf0&scoped=true&lang=pug&"
import script from "./participant.vue?vue&type=script&lang=ts&"
export * from "./participant.vue?vue&type=script&lang=ts&"
import style0 from "./participant.vue?vue&type=style&index=0&id=b1f9faf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f9faf0",
  null
  
)

export default component.exports